<template>
  <div class="add-event-setting-container">
    <!-- 이벤트 조건 -->
    <div class="table-header-wrap" style="padding-top: 20px" v-if="isAddEventPolicy">
      <div class="left-con">
        <div class="subtitle">
          {{ t('page.eventStatus.eventCondition') }}
          <span class="required">*</span>
        </div>
        <!-- 이벤트 조건 -->
      </div>
      <div class="right-con" v-if="!readonly">
        <lego-button @click="openTemplateModal"
          >{{ t('page.eventStatus.findTemplate') }}
        </lego-button>
        <!-- 템플릿 불러오기 -->
      </div>
    </div>
    <div class="select-table-container">
      <div class="select-formbox-wrap">
        <div class="selectbox-col" v-if="!readonly">
          <performance-item
            :metricList="metrics"
            :selectedMetrics="modelValue"
            showTitle
            type="multiple"
            @on-selected-metric="selectMetric"
          />
        </div>
        <div class="formbox-col">
          <no-data :message="t('title.pleaseSelectPerformanceItem')" v-if="!modelValue.length" />
          <c-scroll v-else ref="cscroll">
            <div v-if="metrics.length && modelValue.length" style="width: calc(100% - 16px)">
              <ul>
                <EventRuleItem
                  ref="ruleItem"
                  v-for="(item, index) in modelValue"
                  class="todo"
                  :resourceTypeModel="resourceTypeModel"
                  :resourceTypeModel2="resourceTypeModel2"
                  :productsModel="productsModel"
                  :metrics="metricsOrg"
                  :key="item.removeKey"
                  v-model="modelValue[index]"
                  @remove="removeItem"
                  :disabled="readonly"
                  :chkMode="chkMode"
                  parentClass="formbox-col"
                  @update:Validate="setValidateRules"
                  @setObjectName="perIndividualItems"
                />
              </ul>
            </div>
          </c-scroll>
        </div>
      </div>
    </div>

    <eventTemplateModal
      v-if="templateModalShow"
      :resourceTypeModel="resourceTypeModel"
      :resourceTypeModel2="resourceTypeModel2"
      :opt="opt"
      @selectedTemplate="onSelectedTemplate"
      @close:modal="closeTemplateModal"
    />
  </div>
</template>
<script>
import validationMixin from '@/mixins/validation.mixin.js';
import EventTemplateModal from '../EventTemplateModal.vue';
import EventRuleItem from './EventRuleItem';
import i18nMixin from '@/mixins/i18n.mixin.js';
import PerformanceItem from '@/containers/components/performanceItem/index';
import NoData from '@/containers/components/performanceItem/NoData.vue';
import { ACTION_EVENT } from '@/utils/scpmUtil.js';

export default {
  mixins: [validationMixin, i18nMixin],
  emits: ['setMetricItems', 'setNotification', 'resetRules', 'update:Validate'],
  props: {
    productsModel: {
      type: Array,
      default: () => []
    },
    selectedASG: {
      type: Array,
      default: () => []
    },
    resourceTypeModel: {
      type: String
    },
    resourceTypeModel2: {
      type: String,
      default: null
    },
    modelValue: {
      type: Array
    },
    orgData: {
      type: Object,
      default: () => {
        return null;
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    sch01: {
      type: Array
    },
    chkMode: {
      type: String
    },
    chkMetricItems: {
      type: Boolean,
      default: false
    },
    isAddEventPolicy: {
      type: Boolean,
      default: true
    },
    metric: {
      type: Object,
      default: null
    }
  },
  components: { EventTemplateModal, EventRuleItem, PerformanceItem, NoData },
  data() {
    return {
      metrics: [],
      metricsOrg: [],
      metricModel: {},
      ruleSeq: 0,
      orgDataSet: false,
      templateModalShow: false,
      opt: '',
      resourceSelectedType: 'cluster',
      deleteIdx: 0,
      validateRules: [],
      isShowMessage: false
    };
  },
  computed: {
    selectedMetrics() {
      this.orderValue();
      var reducer = function (accumulator, item) {
        accumulator.push(item.name);
        return accumulator;
      };
      return this.modelValue.reduce(reducer, []);
    },

    isObjecttype() {
      return (
        (this.resourceTypeModel === 'Kubernetes' && this.resourceTypeModel2 !== 'cluster') ||
        (this.resourceTypeModel === 'Load Balancer' && this.resourceTypeModel2 !== 'service') ||
        ['DataOps', 'DataFlow', 'QuickQuery', 'DataWrangler'].includes(this.resourceTypeModel)
      );
    }
  },
  created() {
    this.resourceChanged(this.resourceTypeModel);
  },
  mounted() {
    if (this.metric) {
      this.selectMetric({
        ...this.metric,
        id: this.metric.metricKey,
        name: this.metric.metricName ||  this.metric.name
      });
    }
  },
  watch: {
    modelValue: {
      handler(value) {
        if (!value.length) {
          this.validateRules = [];
          return;
        }
        this.validateRules = this.validateRules.filter((validate) =>
          value.map((val) => `${val.metricKey}#${val.order}`).includes(validate.key)
        );
      },
      deep: true
    },
    validateRules: {
      handler(value) {
        const isValid =
          value.length > 0 ? value.map((val) => val.valid).every((invalid) => !!invalid) : false;
        this.$emit('update:Validate', isValid);
      },
      deep: true
    }
  },
  methods: {
    perIndividualItems(data) {
      const { performanceItemId, individualList } = data;
      const perItemIndex = this.modelValue.findIndex((e) => e.id === performanceItemId);
      if (perItemIndex == -1) return;
      this.modelValue[perItemIndex]['individualItems'] = individualList;
    },
    handlerValidateRules() {
      if (this.$refs.ruleItem) {
        this.$refs.ruleItem.forEach((item) => item.validateForSubmit());
      }
    },
    setValidateRules(value) {
      const existedKeys = this.validateRules.filter((valid) => valid.key === value.key);
      if (!existedKeys.length) {
        this.validateRules.push(value);
      } else {
        this.validateRules.forEach((validate) => {
          if (validate.key === value.key) {
            validate.valid = value.valid;
          }
        });
      }
    },
    metricClone(cloned) {
      cloned.removeKey = cloned.metricKey + this.deleteIdx;
      cloned.objectItems = [];
      cloned.objectModel = '';
      cloned.objectModelDisplay = '';
      cloned.ftCount = '1';
      cloned.thresholdItem = 'range';
      cloned.eventLevel = 'FATAL';
      cloned.disableYn = 'N';
      cloned.metricFunction = 'NULL';
      cloned.thresholdMin = '';
      cloned.thresholdMax = '';
      cloned.statisticsType = 'MAX';
      cloned.statisticsPeriod = 5;
      cloned.check_object = false;
      cloned.check_prefix = false;
      cloned.check_statistics = false;
      cloned.order = this.modelValue.length == 0 ? 0 : this.modelValue.length;
      cloned.eventOccurTimeZone = this.$util.getTimeZoneUser();
      this.deleteIdx++;
      return cloned;
    },

    ruleListToObjectList(data, action = '') {
      let list = data.eventTemplateRuleList;
      let result = [];
      this.ruleSeq = 0;
      for (let i in list) {
        let item = list[i];
        let ruleObj = EventRuleItem.methods.ruleToRuleItem.call(this, item, action);
        ruleObj.seq = this.ruleSeq++;
        ruleObj.removeKey = ruleObj.metricKey + this.deleteIdx
        result.push(ruleObj);
        this.deleteIdx++;
      }
      return result;
    },

    objectValidate(value) {
      return !this.$util.isEmpty(value) || '개별항목을 선택하세요.';
    },
    validate() {
      for (let i in this.modelValue) {
        if (!this.$refs.ruleItem[i].validate()) {
          return false;
        }
      }
      return true;
    },
    removeItem(value) {
      if (value.removeKey) {
        let idx = this.modelValue.findIndex((element) => {
          return element.removeKey === value.removeKey;
        });
        this.modelValue.splice(idx, 1);
      } else {
        let idx = this.modelValue.findIndex((element) => {
          return element.seq === value.seq;
        });
        this.modelValue.splice(idx, 1);
      }
    },
    resourceChanged(resourceTypeModel, isSubResourceTypeModal = false, isChangeService = true) {
      let targetSqs = this.productsModel.map((p) => p.productSq);
      this.selectedASG.forEach((e) => {
        if (e.targetIdList && e.targetIdList.length) targetSqs = targetSqs.concat(e.targetIdList);
      });
      targetSqs = targetSqs.filter((item, idx, arr) => {
        return arr.indexOf(item) === idx;
      });
      let param = {
        targetSqs: targetSqs
      };
      if (this.isObjecttype || isSubResourceTypeModal) {
        param.objectType = this.resourceTypeModel2;
      }

      if (!resourceTypeModel) return;

      if (isChangeService) this.metrics = [];

      this.$http.product
        .post('/v1/console/metrics', param, true, false, {
          headers: { 'X-ResourceType': resourceTypeModel }
        })
        .then((data) => {
          this.metricsOrg = data.contents;
          this.setMetrics(data.contents);

          const valueLenth = this.modelValue.length;
          let arrIndexMetrickeyNotExist = [];

          for (let index = 0; index < valueLenth; index++) {
            const itemRule = this.modelValue[index];
            let metricItem = this.metrics.find((item) => itemRule.metricKey.includes(item.id));
            let lstMetricKey = [];

            // compare Performance Item and rule item. If rule itemn not exist in Performance Item then remove it.
            if (!metricItem) {
              this.metrics.some((item) => {
                let result = false;
                item.children.some((child) => {
                  if (child.metricKey == itemRule.metricKey) {
                    lstMetricKey = item;
                    result = true;
                    return result;
                  }
                });

                if (result) {
                  return result;
                }
              });

              if (!lstMetricKey['id']) {
                arrIndexMetrickeyNotExist.push(index);
              }

              metricItem = lstMetricKey;
            }

            if (!metricItem) continue;
          }

          if (arrIndexMetrickeyNotExist.length) {
            arrIndexMetrickeyNotExist.forEach((idx) => {
              this.modelValue.splice(idx, 1);
            });
          }

          if (this.orgData != null && !this.orgDataSet) {
            this.setTemplate(this.orgData);
            this.orgDataSet = true;
          }
        })
        .catch((error) => {
          this.$alert(error, () => {
            this.setMetrics([]);
            this.setTemplate([]);
            this.orgDataSet = false;
          });
        });
    },

    setMetrics(metrics) {
      let tmp = {};
      const result = [];

      metrics.forEach((item) => {
        if (tmp[item.metricSetName] == null) tmp[item.metricSetName] = [];
        tmp[item.metricSetName].push(item);
      });

      Object.keys(tmp).forEach((key) => {
        let child = this.$util.convertArr(tmp[key], { metricKey: 'id', metricName: 'name' });
        result.push({
          id: tmp[key][0].metricSetKey,
          name: key,
          metricName: key,
          children: child
        });
      });

      this.metrics = result;
    },
    removeMetric(name) {
      let index = this.modelValue.indexOf(name);
      this.removeItem(index);
    },
    selectMetric(item) {
      let newItem = this.metricClone(this.$util.deepCopy(item));
      if (!newItem.name) {
        newItem.name = this.metric.name;
      }
      this.modelValue.unshift(newItem);
    },
    openTemplateModal() {
      this.templateModalShow = true;
    },
    closeTemplateModal() {
      this.templateModalShow = false;
    },
    async onSelectedTemplate({ eventTemplateSq }) {
      const getTemplateDetail = (type) =>
        this.$http.event.get(
          `/v1/console/event-templates/${eventTemplateSq}${type ?? ''}`,
          {},
          true,
          false,
          {
            headers: { 'X-ResourceType': this.resourceTypeModel }
          }
        );
      const [ruleData, notificationData] = await Promise.all([
        getTemplateDetail(),
        getTemplateDetail('/notifications')
      ]).catch((err) => console.log(err));
      await this.$emit('resetRules');
      this.setTemplate(ruleData, notificationData);
    },

    setTemplate(data, notification) {
      const result = this.ruleListToObjectList(data, ACTION_EVENT.FIND_TEMPLATE);
      this.modelValue.push(...result);

      const valueLenth = this.modelValue.length;
      let arrIndexMetrickeyNotExist = [];

      for (let index = 0; index < valueLenth; index++) {
        const itemRule = this.modelValue[index];
        let metricItem = this.metrics.find((item) => itemRule.metricKey.includes(item.id));
        let lstMetricKey = [];

        if (!metricItem) {
          this.metrics.some((item) => {
            let result = false;
            item.children.some((child) => {
              if (child.metricKey == itemRule.metricKey) {
                lstMetricKey = item;
                result = true;
                return result;
              }
            });

            if (result) {
              return result;
            }
          });

          if (!lstMetricKey['id']) {
            arrIndexMetrickeyNotExist.push(index);
          }

          metricItem = lstMetricKey;
        }

        if (!metricItem) continue;

        const findRule = (metricItem.children || []).find(
          (item) => item.metricKey == itemRule.metricKey
        );

        if (!findRule) continue;

        this.modelValue[index].isObjectExist = findRule.isObjectExist;
        this.modelValue[index].disableObject = findRule.disableObject;
        this.modelValue[index].order = index;

        // if (findRule.isObjectExist == 'Y') {
        //   this.value[index].chkObjectItems = false;
        // }
      }

      if (arrIndexMetrickeyNotExist.length) {
        arrIndexMetrickeyNotExist.forEach((idx) => {
          this.modelValue.splice(idx, 1);
        });
      }
      this.$emit('setNotification', notification);
    },
    orderValue() {
      this.modelValue.sort((a, b) => {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        if (a.order === b.order) return 0;
      });
    },
    setMetricItems() {
      this.$emit('setMetricItems');
    }
  }
};
</script>
<style lang="scss" scoped>
ul {
  .todo {
    margin-top: 16px;

    &:first-child {
      margin-top: 0px;
    }
  }
}

.add-event-setting-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.subtitle {
  padding: 10px 0 0 0;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;

  .required {
    color: rgb(255, 0, 0);
  }

  &:first-child {
    padding-top: 0px;
  }
}

.table-header-wrap {
  padding-bottom: 10px;

  &:after {
    content: '';
    clear: both;
    display: table;
  }

  & .left-con {
    float: left;
    width: 40%;
  }

  & .right-con {
    float: right;
    width: 60%;
    text-align: right;
  }
}

.select-table-container {
  height: 100%;
  overflow: auto;
  padding-top: 24px;
}

.select-formbox-wrap {
  display: flex;
  height: 100%;

  .selectbox-col {
    width: 328px;
    border-right: 1px solid #e4e5e7;
  }

  .formbox-col {
    padding-left: 24px;
    flex: 1;
  }
}
</style>
